// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"fec9f903","427":"280f07a9","851":"ed802fa9","950":"bf97fc6a"}[chunkId] + ".chunk.js";
};